<template>
  <button
    class="btn btn-error btn-outline"
    @click="open_modal"
    :disabled="
      clientDetail.client_detail?.uninstalled ||
      latestUninstallAction !== undefined
    "
  >
    <i class="fa-solid fa-link-slash"></i>
    <span v-if="latestUninstallAction">
      {{
        latestUninstallAction.status === "success"
          ? "Đã gỡ cài đặt"
          : "Đang gỡ cài đặt"
      }}
    </span>
    <span v-else>Gỡ cài đặt máy trạm</span>
  </button>
  <dialog id="confirm_uninstall_client" class="modal">
    <div class="modal-box">
      <h3 class="mb-4 text-lg font-bold">Xác nhận gỡ cài đặt máy trạm</h3>

      <div class="py-2">
        <div class="mb-1">
          Nhập <span class="font-bold">{{ agent?.computer_name }}</span> để xác
          nhận gỡ cài đặt máy trạm
        </div>
        <div class="w-full">
          <input class="input w-full" v-model="confirm_name" />
        </div>
      </div>

      <div class="modal-action">
        <form method="dialog" class="flex gap-2">
          <button class="btn" value="cancel">Hủy</button>
          <button
            class="btn btn-primary min-w-28"
            @click="handle_confirm"
            :disabled="agent?.computer_name !== confirm_name"
          >
            <span v-if="action_store.loading.create_action">
              <Loading />
            </span>
            <span v-else> Xác nhận </span>
          </button>
        </form>
      </div>
    </div>
  </dialog>
</template>

<script setup lang="ts">
import Loading from "@/components/LoadingTemplate.vue";
import { onMounted, ref } from "vue";
import { toast } from "vue3-toastify";
import type { client_detail } from "..";
import type { action } from "../ExplorerV2";
import { use_action } from "../ExplorerV2/useAction";
import { use_client_detail } from "../useClientDetail";

const clientDetail = use_client_detail();
const action_store = use_action();
const confirm_name = ref<string>();
defineProps<{
  agent?: client_detail;
}>();

const open_modal = () => {
  const dialog = document.getElementById(
    "confirm_uninstall_client",
  ) as HTMLDialogElement;
  dialog.showModal();
};

const latestUninstallAction = ref<action>();

onMounted(async () => {
  try {
    await action_store.get_action_history({
      type: "uninstall",
      size: 1,
    });
    latestUninstallAction.value =
      action_store.actions && action_store.actions.length > 0
        ? action_store.actions[0]
        : undefined;
  } catch (error) {
    console.error(error);
  }
});

const handle_confirm = async () => {
  try {
    await action_store.create_action({
      type: "uninstall",
    });
    const dialog = document.getElementById(
      "confirm_uninstall_client",
    ) as HTMLDialogElement;
    dialog.close();
  } catch (error) {
    console.error(error);
    toast.error("Đã xảy ra lỗi khi tạo yêu cầu gỡ cài đặt.");
  }
};
</script>
